import * as React from 'react';

export interface DropzoneProps {
  children?: React.ReactNode;
  dataHook?: string;
  className?: string;
  onDrop(files: File[]): void;
}

export default class Dropzone extends React.PureComponent<DropzoneProps> {
  static Overlay: React.FC<{
    children?: React.ReactNode;
  }>;
  static Content: React.FC<{
    children?: React.ReactNode;
  }>;
}
